import { buildUrl } from './Utils'

export const APPLICANT = (applicationId: string): string => {
  return buildUrl(`/api/public/applicants/?application_id=${applicationId}`)
}

export const UPDATE_APPLICANT = (applicantId: string, applicationId: string): string => {
  return buildUrl(`/api/public/applicants/${applicantId}/?application_id=${applicationId}`)
}
